/*
 * XCabinets cart guard (redesign).
 * A configured vanity is one cart line for the cabinet plus one line per paid
 * option, linked by the hidden _bundle property. This keeps them together:
 *  - option lines can't be removed or re-quantified on their own;
 *  - when the vanity's quantity changes or it is removed, its options follow;
 *  - the vanity line gets a "Change options" link back to the configurator,
 *    which replaces this bundle when the customer saves.
 * A kitchen from the kitchen builder is many lines sharing the hidden _kitchen id. Its lines are
 * locked to the quantities the builder set (_kq); the first line (_kcfg) carries "Change kitchen"
 * and "Remove kitchen", and if that line goes, the rest of the kitchen goes with it.
 */
(function () {
  'use strict';

  function getCart() { return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }

  function reconcile(cart) {
    var bundles = {};
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (!p._bundle) return;
      var b = bundles[p._bundle] || (bundles[p._bundle] = { base: null, adds: [] });
      if (p.For) b.adds.push(it); else b.base = it;
    });
    var updates = {};
    var kitchens = {};
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (!p._kitchen) return;
      var k = kitchens[p._kitchen] || (kitchens[p._kitchen] = { main: null, lines: [] });
      k.lines.push(it); if (p._kcfg) k.main = it;
    });
    Object.keys(kitchens).forEach(function (id) {
      var k = kitchens[id];
      k.lines.forEach(function (it) {
        var want = k.main ? (parseInt(it.properties._kq, 10) || it.quantity) : 0;
        if (it.quantity !== want) updates[it.key] = want;
      });
    });
    Object.keys(bundles).forEach(function (k) {
      var b = bundles[k];
      var q = b.base ? b.base.quantity : 0;
      b.adds.forEach(function (a) { var e = parseInt((a.properties || {})._each, 10) || 1; if (a.quantity !== q * e) updates[a.key] = q * e; });
    });
    /* Euro colour upgrade: $50 per cabinet (or vanity) in a non-standard Euro colour, as one line whose
       quantity is the number of cabinets. End panels, fillers, toe kicks and scribe are free in the same colour. */
    var feeLines = [], picked = [], units = 0;
    cart.items.forEach(function (it) {
      if (it.handle === FEE_HANDLE) { feeLines.push(it); return; }
      var pr = it.properties || {};
      if (pr.For || FREE_PARTS.test(it.handle || '')) return;
      var c = pr.Colour || '';
      (it.options_with_values || []).forEach(function (o) { if (o.name === 'Colour') c = o.value; });
      if (UPGRADE.indexOf(String(c).toLowerCase()) < 0) return;
      units += it.quantity;
      if (picked.indexOf(c) < 0) picked.push(c);
    });
    var want = picked.join(', '), feeChange = null, feeAdd = false;
    feeLines.forEach(function (f, n) {
      if (!units || n > 0) updates[f.key] = 0;
      else if (f.quantity !== units || (f.properties || {}).Colours !== want) feeChange = { id: f.key, quantity: units, properties: { Colours: want } };
    });
    if (units && !feeLines.length) feeAdd = true;
    var onlyFee = !Object.keys(updates).some(function (k) { return !feeLines.some(function (f) { return f.key === k; }); });
    var post = function (url, body) { return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }); };
    if (!Object.keys(updates).length && !feeChange && !feeAdd) return Promise.resolve(false);
    var p = Object.keys(updates).length ? post('/cart/update.js', { updates: updates }) : Promise.resolve();
    if (feeChange) p = p.then(function () { return post('/cart/change.js', feeChange); });
    if (feeAdd) p = p.then(function () { return feeVariant(); }).then(function (id) { if (id) return post('/cart/add.js', { items: [{ id: id, quantity: units, properties: { Colours: want } }] }); });
    return p.then(function () { return onlyFee ? 'fee' : true; });
  }
  var FEE_HANDLE = 'colour-upgrade', feeId = null;
  var FREE_PARTS = /(end-gable|return-panel|filler|toe-kick|scribe)/;
  var UPGRADE = ['matte cream', 'matte pebble grey', 'matte graphite', 'matte navy', 'matte black', 'gloss cream', 'gloss light grey', 'gloss grey', 'gloss black'];
  function feeVariant() {
    if (feeId) return Promise.resolve(feeId);
    return fetch('/products/' + FEE_HANDLE + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (p) { feeId = p.variants[0].id; return feeId; }).catch(function () { return null; });
  }
  function refreshBubble() {
    fetch('/?sections=cart-icon-bubble', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (s) {
      var el = document.getElementById('cart-icon-bubble'); if (!el || !s['cart-icon-bubble']) return;
      var d = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (d) el.innerHTML = d.innerHTML;
    }).catch(function () {});
  }

  function decorate(cart) {
    cart.items.forEach(function (it, i) {
      var p = it.properties || {};
      if (it.handle === FEE_HANDLE) {
        document.querySelectorAll('#CartItem-' + (i + 1) + ', #CartDrawer-Item-' + (i + 1)).forEach(function (row) {
          row.classList.add('xc-addon-line');
          row.querySelectorAll('quantity-input, cart-remove-button, quantity-popover, .quantity-popover-container').forEach(function (n) { n.style.display = 'none'; });
          var d = row.querySelector('.cart-item__details') || row, note = d.querySelector('.xc-addon-note');
          if (!note) { note = document.createElement('p'); note.className = 'xc-addon-note'; d.appendChild(note); }
          note.textContent = it.quantity + (it.quantity === 1 ? ' cabinet' : ' cabinets') + ' × $' + Math.round(it.price / 100) + '. Panels, fillers and toe kicks in the same colour are included.';
        });
        return;
      }
      if (p._kitchen) return decorateKitchen(it, i, cart);
      if (!p._bundle) return;
      var rows = document.querySelectorAll('#CartItem-' + (i + 1) + ', #CartDrawer-Item-' + (i + 1));
      rows.forEach(function (row) {
        var details = row.querySelector('.cart-item__details') || row;
        if (p.For) {
          row.classList.add('xc-addon-line');
          row.querySelectorAll('quantity-input, cart-remove-button, quantity-popover, .quantity-popover-container').forEach(function (n) { n.style.display = 'none'; });
          if (!row.querySelector('.xc-addon-note')) {
            var note = document.createElement('p');
            note.className = 'xc-addon-note';
            note.textContent = /^XK/.test(p._bundle) ? 'Part of the cabinet above. Change it from the cabinet.' : 'Part of your configured vanity. Change it from the vanity.';
            details.appendChild(note);
          }
        } else if (p._cfg && !row.querySelector('.xc-edit')) {
          var a = document.createElement('a');
          a.className = 'xc-edit';
          a.href = String(it.url || '').split('?')[0] + '#' + p._cfg + '&replace=' + p._bundle;
          a.textContent = 'Change options';
          details.appendChild(a);
        }
      });
    });
  }

  function decorateKitchen(it, i, cart) {
    var p = it.properties, id = p._kitchen;
    var rows = document.querySelectorAll('#CartItem-' + (i + 1) + ', #CartDrawer-Item-' + (i + 1));
    rows.forEach(function (row) {
      var details = row.querySelector('.cart-item__details') || row;
      row.classList.add('xc-kitchen-line');
      row.querySelectorAll('quantity-input, cart-remove-button, quantity-popover, .quantity-popover-container').forEach(function (n) { n.style.display = 'none'; });
      if (!p._kcfg) {
        if (!row.querySelector('.xc-addon-note')) {
          var note = document.createElement('p');
          note.className = 'xc-addon-note';
          note.textContent = 'Part of your kitchen. Change it from the kitchen builder.';
          details.appendChild(note);
        }
        return;
      }
      if (row.querySelector('.xc-kitchen-tools')) return;
      var box = document.createElement('p');
      box.className = 'xc-kitchen-tools';
      var a = document.createElement('a');
      a.className = 'xc-edit';
      a.href = String(p._kurl || '/').split('#')[0] + '#k=' + encodeURIComponent(p._kcfg) + '&replace=' + encodeURIComponent(id);
      a.textContent = 'Change kitchen';
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'xc-kitchen-remove';
      b.textContent = 'Remove kitchen';
      b.style.cssText = 'margin-left:14px;background:none;border:0;padding:0;font:inherit;text-decoration:underline;cursor:pointer;color:inherit';
      b.addEventListener('click', function () {
        b.disabled = true;
        var u = {}, attrs = {};
        cart.items.forEach(function (x) { if (x.properties && x.properties._kitchen === id) u[x.key] = 0; });
        attrs['Kitchen ' + id] = '';
        fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: u, attributes: attrs }) })
          .then(function () { window.location.reload(); });
      });
      box.appendChild(a); box.appendChild(b);
      details.appendChild(box);
    });
  }

  var busy = false;
  function run() {
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      return reconcile(cart).then(function (changed) {
        if (changed === 'fee' && !/^\/cart/.test(location.pathname)) { refreshBubble(); return getCart().then(decorate); }
        if (changed) {
          // Options were brought back in line with their vanity: show the corrected cart.
          window.location.reload();
          return;
        }
        decorate(cart);
      });
    }).catch(function () {}).then(function () { busy = false; });
  }

  var t;
  function soon() { clearTimeout(t); t = setTimeout(run, 250); }
  window.xcCartGuardRun = soon;

  function watch() {
    run();
    var EV = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
    if (typeof window.subscribe === 'function' && EV && EV.cartUpdate) {
      window.subscribe(EV.cartUpdate, soon);
    }
    var targets = document.querySelectorAll('cart-items, cart-drawer-items, cart-drawer');
    if (targets.length && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { if (!busy) soon(); });
      targets.forEach(function (n) { mo.observe(n, { childList: true, subtree: true }); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
